import { TZoneTypes, getUserPref } from '@eventr/common'
import { signal } from '@preact/signals-react'

export const userPrefShowDestTime = signal<TZoneTypes>(
    getUserPref('itinerary', 'showDestTime') ?? 'itinLocal'
)

export const userPrefLoginMethod = signal<'password' | 'email'>(
    getUserPref('account', 'loginMethod') ?? 'email'
)

const sortShowDevOverlayFromPref = () => {
    const userPref = getUserPref('account', 'showDevOverlay')
    if (['dev', 'prod'].includes(userPref)) {
        return userPref
    }
    return ['dev', 'test', 'local'].includes(
        localStorage.getItem('REACT_APP_STAGE') ?? ''
    )
        ? 'dev'
        : 'prod'
}

export const userPrefShowDevOverlay = signal<'dev' | 'prod'>(
    sortShowDevOverlayFromPref()
)
